import React from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import { NodeFragmentWithGroups, NodeFragmentWithoutGroups } from 'services/apollo/fragments';
import { useFeatureFlagState } from 'context';

interface GetNameProps {
  nodeId: any;
}

export const GetName: React.FC<GetNameProps> = ({ nodeId }) => {
  const client = useApolloClient();
  const { groupsFeatureFlag } = useFeatureFlagState();

  try {
    const readNode: any = client.readFragment({
      id: nodeId,
      fragment: groupsFeatureFlag ? NodeFragmentWithGroups : NodeFragmentWithoutGroups,
    });
    return <>{readNode?.title ? readNode.title : 'Folder'}</>;
  } catch (err) {
    return <>{'Folder'}</>;
  }
};
